import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

interface Props {
  history: string[];
  isLoading: boolean;
}

export const StatusHistory: React.FC<Props> = ({ history, isLoading }) => {
  if (history.length === 0) return null;
  return (
    <Box sx={{ px: 1.5, py: 1, borderTop: "1px solid rgba(0,0,0,0.08)" }}>
      {history.map((status, idx) => {
        const isLast = idx === history.length - 1;
        const showSpinner = isLoading && isLast;
        return (
          <Box
            key={`${idx}-${status}`}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              opacity: isLast ? 1 : 0.6,
              fontSize: "0.85rem",
            }}
          >
            {showSpinner ? (
              <CircularProgress size={12} thickness={6} />
            ) : (
              <CheckIcon sx={{ fontSize: 14, color: "success.main" }} />
            )}
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              {status}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
